module.exports = __webpack_public_path__ + "static/media/bg-snow-2.70c63ac0.svg";